import type { i18n as I18nType } from 'i18next'

import { messages } from './messages'

export const TRANSLATION_NAMESPACE = 'ui.form'

export const setupTranslations = (instance: I18nType) => {
  instance.addResourceBundle('en', TRANSLATION_NAMESPACE, messages, true, true)
}
